import {
  SET_FILTERS,
  CLEAR_FILTERS,
  SET_PAGE,
  SET_PAGE_SIZE,
  SET_SEARCH,
  SET_SORT,
  FETCH_CANDIDATES_REQUEST,
  FETCH_CANDIDATES_SUCCESS,
  FETCH_CANDIDATES_FAILURE,
} from '../actions/actionTypes';
import { CandidatesAction } from '../actions/candidatesActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface CandidatesState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: CandidatesState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
};

export default function candidatesReducer(
  state: CandidatesState = initialState,
  action: CandidatesAction,
): CandidatesState {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };

    case CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };

    case SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };

    case SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };

    case SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };

    case SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };

    case FETCH_CANDIDATES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_CANDIDATES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };

    case FETCH_CANDIDATES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
